import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PublicContext from '../PublicContext'
import MobileCreateSpecialistSlotPage from './Mobile/MobileCreateSpecialistSlotPage'
import ComputerCreateSpecialistSlotPage from './Computer/ComputerCreateSpecialistSlotPage'
import TabletCreateSpecialistSlotPage from './Tablet/TabletCreateSpecialistSlotPage'
import { screenSize } from '../../Common/Common'
import dayjs from 'dayjs'
import { post } from '../../Common/api'
import { useNavigate } from 'react-router'

export default function CreateSpecialistSlotPage () {
  const { box, setSiderTitle, data, setData, user } = useContext(PublicContext)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const onFinishFailed = () => {
    setLoading(false)
  }

  const sort = (optionA, optionB) => (
    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
  )

  const onFinish = (values) => {
    setLoading(true)
    const phone = values.phone
    if ((phone.slice(0, 3) === '+06') || (phone.slice(0, 3) === '+07')) {
      values.phone = '+33' + phone.slice(2)
    }
    setData({ ...data, country: values.country, civility: values.civility })
    values = {
      ...values,
      phone: values.phone.slice(1),
      box_id: box.id,
      is_now: false,
      specialist: true,
      created_by: user.from || 'web'
    }
    post({
      url: 'public/slots',
      params: values,
      onSuccess: (json) => {
        if (json.sms_confirmed) {
          navigate(`/slots/${json.id}`)
        } else {
          navigate(`/box/${box.id}/confirm_slot/${json.id}`)
        }
      }
    })
  }

  const civilityOptions = [
    { value: 'MR', label: 'M.' },
    { value: 'MS', label: 'Mme.' }
  ]

  const initialValues = {
    start_timestamp: data?.slotTime?.start,
    end_timestamp: data?.slotTime?.end,
    calendar_id: data?.calendarId,
    reason_id: data?.reasonId,
    date: dayjs(data.slotTime.time),
    country: 'FR'
  }

  useEffect(() => {
    setSiderTitle(t('Public.CreateSlotPage.title'))
  }, [])

  const slotForm = {
    Mobile: MobileCreateSpecialistSlotPage,
    Computer: ComputerCreateSpecialistSlotPage,
    Tablet: TabletCreateSpecialistSlotPage
  }

  const ResponsiveForm = slotForm[screenSize()]

  return (
    <ResponsiveForm
      loading={loading}
      onFinishFailed={onFinishFailed}
      sort={sort}
      minimumAge={box?.teleconsulting_company_minimum_age}
      onFinish={onFinish}
      civilityOptions={civilityOptions}
      initialValues={initialValues}
    />
  )
}
